import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
    return (
        <a
            href="https://wa.me/4917620366268?text=Hallo%20RAPID%20Key%20%26%20Go%2C%20ich%20habe%20eine%20Frage%3A"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp Chat starten"
            data-testid="whatsapp-fab"
            className="fixed z-[60] bottom-5 right-5 md:bottom-7 md:right-7 group inline-flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-lg shadow-black/25 hover:bg-[#1DA851] hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
        >
            <span className="relative flex h-9 w-9 items-center justify-center">
                <span className="absolute inset-0 rounded-full bg-white/25 animate-ping" />
                <MessageCircle size={22} strokeWidth={2.25} />
            </span>
            <span className="font-body text-xs tracking-[0.18em] uppercase font-semibold hidden sm:inline">
                WhatsApp Chat
            </span>
        </a>
    );
}
